import { usePackAssets } from "lib/hooks";
import { FC } from "react";
import { ItemLevels } from "lib/hooks/usePackAssets";
import { Box, Flex, VStack } from '@chakra-ui/react';
import { StaticAsset } from "../single-asset/staticAsset";

const renderGroup = (item) => {
  if (item.level === ItemLevels.ROW) {
    return renderRow(item.children);
  }

  return (
    <Box w={"100%"} py={5} key={`${item.id}-group`}>
      <VStack spacing={2} w={"100%"}>
        { item.children.map((i) => (
          renderItem(i)
        ))}
      </VStack>
    </Box>
  );
}

const renderRow = (row) => (
  <Flex w={"100%"} gap={5} key={`${row.id}-row`}>
    { row.children.map(c => (
      <Box key={c.id} flex={1}>
        { renderItem(c) }
      </Box>
    ))}
  </Flex>
);

const renderAsset = (item) => (
  <Box
    layerStyle={'with-asset-wrapper'}
    borderColor={'border.200'}
    w={"100%"}
    key={`${item.id}-asset`}
  >
    <StaticAsset asset={item} />
  </Box>
)

const renderItem = (item) => {
  switch (item.level) {
    case ItemLevels.GROUP:
      return renderGroup(item);
    case ItemLevels.ROW:
      return renderRow(item);
    default:
      return renderAsset(item);
  }
}

export const AssetListing: FC<{template: any}> = ({ template }) => {
  const { data } = usePackAssets(template);

  if (!data) {
    return null;
  }

  return (
    <VStack spacing={2} w={"100%"}>
      { data.map(d => renderItem(d)) }
    </VStack>
  );
}
